import { render } from "./Outgoing.vue?vue&type=template&id=f67350aa"
import script from "./Outgoing.vue?vue&type=script&lang=js"
export * from "./Outgoing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/area/overview/Outgoing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f67350aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f67350aa', __exports__)) {
    api.reload('f67350aa', __exports__)
  }
  
  module.hot.accept("./Outgoing.vue?vue&type=template&id=f67350aa", () => {
    api.rerender('f67350aa', render)
  })

}


export default __exports__